import { AnalyticsEvent, fireGtmEvent } from 'src/utils/new-analytics';

export const freeToPaidUpsellPrompt = {
  freeSelected() {
    fireGtmEvent(AnalyticsEvent.FreeToPaidUpsellPromptFreeSelected, {});
  },
  paidSelected() {
    fireGtmEvent(AnalyticsEvent.FreeToPaidUpsellPromptPaidSelected, {});
  },
  cancelled() {
    fireGtmEvent(AnalyticsEvent.FreeToPaidUpsellPromptCancelled, {});
  },
};
